export const iconFontAwesomeHumanitarianRadiation = (
	<i className="fa-solid fa-radiation"></i>
);
